import {
  Box,
  styled,
  TableRow,
  TableCell,
  Button,
  Grid,
  TextField,
  InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React, { useEffect, useState } from 'react';
import PageHeader from '../../../components/PageHeader';
import Table from '../../../components/Table';
import { Link } from 'react-router-dom';
import { TableResponse } from '../../../schema/helper';
import { api } from '../../../api';
import GateFromInput from '../../../components/formInput/GateFromInput';
import AreaFromInput from '../../../components/formInput/AreaFromInput';
import CardTypeFromInput from '../../../components/formInput/CardTypeFromInput';

const tableHead = [
  'กลุ่มประตู',
  'จำนวนประตู',
  'จำนวนบุคคลเริ่มต้น',
  'จำนวนบุคคลในกลุ่มประตู',
  'เพิ่มเติม'
];

interface GateGroupAdminDashbroad {
  id: number;
  group_name: string;
  gate_count: number;
  person_count: number;
  person_in_count: number;
}

const GateGroupPage: React.FC = () => {
  const [data, setData] = useState<TableResponse<GateGroupAdminDashbroad> | null>(null);

  const [filterName, setFilterName] = useState<string>('');
  const [filterGateId, setFilterGateId] = useState<number | null>(null);
  const [filterAreaId, setFilterAreaId] = useState<number | null>(null);
  const [filterCardId, setFilterCardId] = useState<number | null>(null);
  // const [areas, setAreas] = useState<Area[]>([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() => {
    const searchParams = new URLSearchParams();
    if (filterName) {
      searchParams.set('name', `${filterName}`);
    }
    if (filterGateId) {
      searchParams.set('gate_id', `${filterGateId}`);
    }
    if (filterAreaId) {
      searchParams.set('area_id', `${filterAreaId}`);
    }
    if (filterCardId) {
      searchParams.set('card_id', `${filterCardId}`);
    }
    searchParams.set('offset', `${page * rowsPerPage}`);
    searchParams.set('limit', `${rowsPerPage}`);
    api
      .get<TableResponse<GateGroupAdminDashbroad>>(`/gate-group/table`, { params: searchParams })
      .then((res) => {
        const { data } = res;
        setData(data);
      });
  }, [filterName, filterGateId, filterAreaId, filterCardId, page, rowsPerPage]);

  return (
    <Container>
      <PageHeader text="กลุ่มประตู" />
      <Grid container spacing={2} marginTop={1}>
        <Grid item md={2.75}>
          <TextField
            id="search-text-label"
            label="ค้นหาชื่อกลุ่มประตู"
            variant="outlined"
            placeholder="ค้นหาชื่อกลุ่มประตู"
            onChange={(event) => setFilterName(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            autoComplete="off"
          />
        </Grid>
        <Grid item md={2.75}>
          <GateFromInput value={filterGateId} onChange={(value) => setFilterGateId(value)} />
        </Grid>
        <Grid item md={2.75}>
          <AreaFromInput value={filterAreaId} onChange={(value) => setFilterAreaId(value)} />
        </Grid>
        <Grid item md={2.75}>
          <CardTypeFromInput
            value={filterCardId}
            onChange={(value) => setFilterCardId(value)}
            canSelectAll={true}
          />
        </Grid>

        <Grid item md sx={{ display: 'flex', justifyContent: 'end', height: '50px' }}>
          <Button component={Link} to={`/gate-group/create`} variant="contained" color="primary">
            เพิ่มข้อมูล
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ mt: 2 }}>
        <Table
          heads={tableHead}
          count={data?.total ? data.total : 0}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        >
          {data?.data.map((data, index) => (
            <TableRow key={index}>
              <TableCell align="center">{data.group_name}</TableCell>
              <TableCell align="center">{data.gate_count}</TableCell>
              <TableCell align="center">{data.person_count}</TableCell>
              <TableCell align="center">{data.person_in_count}</TableCell>
              
              <TableCell align="center">
                <Grid container spacing={2} rowSpacing={2} justifyContent="center">
                  {/* <Grid item>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => goToDetailPage(data.id)}
                    >
                      ข้อมูล
                    </Button>
                  </Grid> */}
                  <Grid item>
                    <Button
                      component={Link}
                      to={`/gate-group/${data.id}/edit`}
                      variant="contained"
                      color="warning"
                    >
                      แก้ไข
                    </Button>
                  </Grid>
                </Grid>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </Box>
    </Container>
  );
};

export default GateGroupPage;

const Container = styled('div')`
  padding: 24px;
`;
